import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Path.svg",
  "use": "Path.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Path.svg\"><path d=\"M56.01,46.0209a2,2,0,0,1-2,2h-22a2,2,0,1,1,0-4h22A2,2,0,0,1,56.01,46.0209Zm-39-11a3,3,0,1,1,3-3A3,3,0,0,1,17.01,35.0208Zm1-17a2,2,0,0,1,2-2h22a2,2,0,1,1,0,4h-22A2,2,0,0,1,18.0106,18.0209Zm6,14h0a2,2,0,0,1,2-2h22a2,2,0,0,1,2,2h0a2,2,0,0,1-2,2h-22A2,2,0,0,1,24.0106,32.0209Zm-1,17a3,3,0,1,1,3-3A3,3,0,0,1,23.01,49.0208Zm-9-31a3,3,0,1,1-3-3A3,3,0,0,1,14.0106,18.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol